<template>
  <div style="height: 100%; padding: 20px">
    <div style="text-align: center; font-size: 30px; margin-bottom: 30px">
      订单 {{ orderInfo.ord_no }} 详情
    </div>
    <div>
      <div class="div_titel">客户基本信息:</div>
      <el-row :gutter="24" style="margin: 20px 0px">
        <el-col :span="8">客户名字：{{ cstInfo.company_name }}</el-col>
        <el-col :span="8">客户来源：{{ cstInfo.source_id }} </el-col>
        <el-col :span="8">国家/地区：{{ cstInfo.nation_id }}</el-col>
      </el-row>
      <el-row :gutter="24" style="margin: 20px 0px">
        <el-col :span="24">客户备注：{{ cstInfo.cst_remark }}</el-col>
      </el-row>
      <div class="div_titel">订单基本信息:</div>
      <el-row :gutter="24" style="margin: 20px 0px">
        <el-col :span="8">订单编码：{{ orderInfo.ord_no }} </el-col>
        <el-col :span="8">下单日期：{{ orderInfo.create_time }}</el-col>
        <el-col :span="8">订单状态：{{ orderInfo.ord_status }}</el-col>
      </el-row>
    </div>
    <div class="div_titel">订单IMEI编码:</div>
    <div class="content" style="margin-top: 20px">
      <el-table
        :data="dataSource"
        :span-method="spanMethod"
        style="width: 100%; font-size: 12px"
      >
        <el-table-column prop="pdt_model" label="产品编码" width="230" />
        <el-table-column prop="pdt_dep" label="产品描述" width="300" />
        <el-table-column prop="pdt_num" label="销售数量" width="100" />
        <el-table-column prop="pdt_sale_price" label="销售单价" width="100" />
        <el-table-column prop="imei" label="IMEI编码" />
      </el-table>
    </div>
  </div>
  <div
    style="
      position: fixed; /* 固定在视口 */
      bottom: 0; /* 贴底 */
      width: 100%; /* 占满宽度 */
      text-align: center; /* 文字居中 */
      padding: 5px 0;
      background-color: #f0f0f0;
      color: #333;
    "
  >
    <p>Copyright © 2025 GEEKID.COM</p>
    <p>All rights reserved.</p>
  </div>
</template>
<script>
import { ref, reactive, toRefs, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { showOrderIMEI } from "@/network/showDetails.js";
import { useRoute } from "vue-router";
import { mergeTableRows, objectSpanMethod } from "@/utils/toolsFunction.js";
export default {
  components: {},
  setup() {
    let formatObj = {};
    const colAry = [0, 1, 2, 3];
    const route = ref(useRoute());
    const state = reactive({
      dataSource: [],
      orderInfo: [],
      cstInfo: [],
    });
    const printInfo = route.value.query.ordId || route.value.query.ordId;
    const getList = () => {
      showOrderIMEI({ data: printInfo }).then((res) => {
        if (res.code == 0) {
          state.orderInfo = res.data.orderInfo;
          state.cstInfo = res.data.cstInfo;
          state.dataSource = res.data.lists;
          formatObj = mergeTableRows(state.dataSource, "ord_details_id");
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const spanMethod = (o) => {
      return objectSpanMethod({ ...o, formatObj, colAry });
    };
    onMounted(() => {
      getList();
    });
    return {
      ...toRefs(state),
      spanMethod,
    };
  },
};
</script>
<style scoped>
.div_titel {
  font-size: 14px;
  font-weight: 400;
  border-left: 5px solid darkorange;
  padding-left: 5px;
}
.el-table__body-wrapper {
  height: auto !important;
}
</style>
